/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/advancedMenuItemView.html';

export default class AdvancedMenuItemView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.tagName = opts.tagName || 'li';
		opts.template = opts.template || Template;
		super(opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'AdvancedMenuItemView';
	}
}
